{
  "table": {
    "id": "ID",
    "name": "Nombre",
    "type": "Tipo",
    "nextDate": "Próxima fecha",
    "noOfAttachedProducts": "No. de productos incluidos",
    "action": "Acción",
    "noOfSchedules": "No. de horarios"
  },
  "action": "Editar",
  "addModal": {
    "title": "Añadir horario nuevo",
    "name": "Nombre",
    "scheduleDate": "Programar fecha",
    "addDate": "Agregar fecha nueva",
    "update": "Actualizar",
    "type": "Tipo",
    "manual": "Manual",
    "auto": "Automático",
    "create": "Crear",
    "updateTitle": "Actualizar horario",
    "duplicateError": "No se pueden duplicar las fechas en el calendario"
  },
  "modelName": "Horario de Negociación"
}
